import { FC, Fragment, memo, useEffect, useState } from "react";
import "./VideoTutorial.scss";
import React from "react";
import Modal from "../Modal/Modal";
import { IEnchancedDrawerChildComponentProps } from "../Drawer/Drawer";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { EPath, Paths } from "../../Core/EPath";

interface IVideoTutorialModalProps {
    url: string;
    title: string;
    showModal: boolean;
    setShowModal: (showModal: boolean) => void;
}

interface ILoomProps {
    url: string;
    title: string;
}

interface IVideoTutorialContent {
    title: string;
    imageUrl: string;
    videoUrl: string;
}

interface IVideoTutorialProps extends IEnchancedDrawerChildComponentProps {}

const VideoTutorial: FC<IVideoTutorialProps> = ({ setIsDrawerFocused }) => {
    const [isTutorialModalOpen, setIsTutorialModalOpen] = useState(false);

    const { t, i18n } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        setIsDrawerFocused && setIsDrawerFocused(!(isTutorialModalOpen));
    }, [isTutorialModalOpen]);

    const openTutorialModal = () => setIsTutorialModalOpen(true)

    const getContent = (): IVideoTutorialContent | null => {
        let imageUrl;
        let videoUrl;

        switch (true) {
            case Paths.isActiveRootPath(location, [EPath.REVIEW, EPath.REVIEW_DETAIL, EPath.REVIEW_COPILOT, EPath.REVIEW_ANONYMISATION, EPath.HOME]):
                
                imageUrl = process.env.REACT_APP_IS_RESELLER ? (
                    i18n.language === 'nl' ? "https://cdn.loom.com/sessions/thumbnails/61b0e4114ef64e258004933bd33075c5-06a4b9a7005176e1-full-play.gif" :
                    i18n.language === 'fr' ? "https://cdn.loom.com/sessions/thumbnails/5516300d5f164625a43e840c9df7c36c-7e5432b0d4cc5a1c-full-play.gif" :
                    "https://cdn.loom.com/sessions/thumbnails/bcc6f46e8fd245cd9849c5a90af2b5c9-4208ddc8dbb444b2-full-play.gif"
                ) : "https://cdn.loom.com/sessions/thumbnails/582d76329b8f4de889f9f62060a7c4d1-with-play.gif";

                videoUrl = process.env.REACT_APP_IS_RESELLER ? (
                    i18n.language === 'nl' ? "https://www.loom.com/embed/61b0e4114ef64e258004933bd33075c5?sid=41e70819-ce8c-49a8-a328-95b76ac3feea" :
                    i18n.language === 'fr' ? "https://www.loom.com/embed/5516300d5f164625a43e840c9df7c36c?sid=28481517-b273-4683-b8ce-d04085941a83" :
                    "https://www.loom.com/embed/bcc6f46e8fd245cd9849c5a90af2b5c9?sid=b8cc0f4c-2775-446a-853c-c14e6e78f4cd"
                ) : "https://www.loom.com/embed/582d76329b8f4de889f9f62060a7c4d1?sid=4a1a162a-c7f4-497f-bf8f-b9fd8e22e0da";
            
                return {
                    title: t("tutorials.review.title"),
                    imageUrl,
                    videoUrl
                }
            case Paths.isActiveRootPath(location, [EPath.DRAFT, EPath.DRAFT_CREATE, EPath.DRAFT_DETAIL, EPath.TEMPLATE, EPath.TEMPLATE_CREATE, EPath.TEMPLATE_DETAIL]):
                
                imageUrl = process.env.REACT_APP_IS_RESELLER ? (
                    i18n.language === 'nl' ? "https://cdn.loom.com/sessions/thumbnails/ef8305b59c264a98b93ce137b6a1fa3e-1007885f94a89049.jpg" :
                    i18n.language === 'fr' ? "https://cdn.loom.com/sessions/thumbnails/d03a4fcbd02a45c4af3ad6073ca59be4-eaa79d0ef9ab64ff-full-play.gif" :
                    "https://cdn.loom.com/sessions/thumbnails/a239ea5124a14002a5fdf601b1a7769b-c2f0f64aa8363b20-full-play.gif"
                ) : "https://cdn.loom.com/sessions/thumbnails/582d76329b8f4de889f9f62060a7c4d1-with-play.gif";

                videoUrl = process.env.REACT_APP_IS_RESELLER ? (
                    i18n.language === 'nl' ? "https://www.loom.com/embed/ef8305b59c264a98b93ce137b6a1fa3e?sid=fe3a2876-76f9-4a5a-9c9c-21a2e0859919" :
                    i18n.language === 'fr' ? "https://www.loom.com/embed/d03a4fcbd02a45c4af3ad6073ca59be4?sid=0ab4f459-e6aa-4101-89f5-d911139ecb73" :
                    "https://www.loom.com/embed/a239ea5124a14002a5fdf601b1a7769b?sid=5b2afbc2-ca34-4e93-94fa-11651f398196"
                ) : "https://www.loom.com/embed/582d76329b8f4de889f9f62060a7c4d1?sid=4a1a162a-c7f4-497f-bf8f-b9fd8e22e0da";

                return {
                    title: t("tutorials.drafting.title"),
                    imageUrl,
                    videoUrl
                }
            case Paths.isActivePath(location, EPath.DISCOVERY):
                return {
                    title: t("tutorials.discovery.title"),
                    imageUrl:"https://cdn.loom.com/sessions/thumbnails/1903835a078d4c19855d80f2f9a7fe9d-with-play.gif",
                    videoUrl: "https://www.loom.com/embed/1903835a078d4c19855d80f2f9a7fe9d?sid=b9041af3-0d41-4a03-955c-38d88aeb0bb4"
                }
            case Paths.isActivePath(location, EPath.TRAINING):
                return {
                    title: t("tutorials.training.title"),
                    imageUrl:"https://cdn.loom.com/sessions/thumbnails/1903835a078d4c19855d80f2f9a7fe9d-with-play.gif",
                    videoUrl: "https://www.loom.com/embed/1903835a078d4c19855d80f2f9a7fe9d?sid=b9041af3-0d41-4a03-955c-38d88aeb0bb4"
                }
            default:
                return null
        }
    }

    const content  = getContent()

    if (!content) return <Fragment />

    const { title, videoUrl, imageUrl} = content
 
    return (
        <div className="video-tut-container">
            <h4>{title}</h4>
            <img alt="Trainings video preview" onClick={openTutorialModal} className="img" src={imageUrl} />
            
            <VideoTutorialModal
                url={videoUrl}
                title={title}
                showModal={isTutorialModalOpen}
                setShowModal={setIsTutorialModalOpen}
            />
        </div>
    )
}

const VideoTutorialModal: FC<IVideoTutorialModalProps> = ({ showModal, url, title, setShowModal }) => {
    return <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title={title}
        content={<Loom url={url} title={title} />}
    />
}

const Loom: FC<ILoomProps> = ({ url, title }) => {
    return (
        <div className="wistia-video-container">
            <div style={{ flex: 1 }}>
                <div className="wistia_responsive_padding" style={{ padding: '64.98194945848375% 0 0 0', position: 'relative' }}>
                    <div className="wistia_responsive_wrapper" style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}>
                        <iframe rel="preload" src={`${url}?hideEmbedTopBar=true&hide_share=true&hide_owner=true&hide_title=true&autoplay=true`} title={title} allow="autoplay; fullscreen" allowTransparency={true} className="iframe" name="loom_embed" allowFullScreen width="100%" height="100%"></iframe>
                    </div>
                </div>
                <script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>
            </div>
        </div>
    )
}
export default memo(VideoTutorial)
